import { render } from "./CollectionAddressesPage.vue?vue&type=template&id=614e22f0&scoped=true"
import script from "./CollectionAddressesPage.vue?vue&type=script&lang=js"
export * from "./CollectionAddressesPage.vue?vue&type=script&lang=js"

import "./CollectionAddressesPage.vue?vue&type=style&index=0&id=614e22f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614e22f0"]])

export default __exports__